module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalk.275a7f69.mp3";